// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
// Components
import { BaseComponent } from './views/theme/base/base.component';
// Auth
// import {AuthGuard} from './core/auth';
import { MadAuthGuard } from './core/mad-auth/mad-auth.guard';
import { MadPermissionGuard } from './core/mad-auth/mad-permission.guard';
import { IsSignedInGuard } from './core/mad-auth/is-signed-in.guard';
import { PostLoginComponent } from './views/pages/mad-auth/post-login/post-login.component';

const routes: Routes = [
    // {path: 'auth', loadChildren: () => import('./views/pages/auth/auth.module').then(m => m.AuthModule)},
    {
        path: 'mad-auth',
        canActivate: [IsSignedInGuard],
        loadChildren: () => import('./views/pages/mad-auth/mad-auth.module').then(m => m.MadAuthModule)
    },
    { path: 'error', loadChildren: () => import('./views/pages/error/error.module').then(m => m.ErrorModule) },
    {
        path: 'org/:org',
        children: [
            {
                path: '',
                component: BaseComponent,
                canActivate: [MadAuthGuard],
                children: [
                    {
                        path: 'dashboard',
                        loadChildren: () => import('./views/pages/dashboard/dashboard.module').then(m => m.DashboardModule),
                    },
                    {
                        path: 'my-task',
                        loadChildren: () => import('./views/pages/my-task/my-task.module').then(m => m.MyTaskModule),
                    },
                    {
                        path: 'user-management',
                        loadChildren: () => import('./views/pages/user-management/user-management.module').then(m => m.UserManagementModule),
                    },
                    {
                        path: 'admin-management',
                        loadChildren: () => import('./views/pages/admin-management/admin-management.module').then(m => m.AdminManagementModule),
                    },
                    {
                        path: 'comparable',
                        loadChildren: () => import('./views/pages/comparable/comparable.module').then(m => m.ComparableModule),
                    },
                    {
                        path: 'assignment',
                        loadChildren: () => import('./views/pages/assignment/assignment.module').then(m => m.AssignmentModule),
                    },
                    {
                        path: 'template',
                        loadChildren: () => import('./views/pages/template/template.module').then(m => m.TemplateModule),
                        canActivate: [MadPermissionGuard],
                        data: {
                            permissions: ['template:view', 'template:crud']
                        }
                    },
                    {
                        path: 'admin',
                        loadChildren: () => import('./views/pages/mad-usermanagement/mad-usermanagement.module').then(m => m.MadUsermanagementModule),
                        canActivate: [MadPermissionGuard],
                        data: {
                            permissions: ['role:view', 'role:crud']
                        }
                    },
                    {
                        path: 'terms-of-engagements',
                        loadChildren: () => import('./views/pages/terms-of-engagements/terms-of-engagements.module').then(m => m.TermsOfEngagementsModule)
                    },
                    {
                        path: 'reviews',
                        loadChildren: () => import('./views/pages/reviews/reviews-lazy-loading.module').then(m => m.ReviewsLazyLoadingModule)
                    },
                    {
                        path: 'repository',
                        loadChildren: () => import('./views/pages/repository/repository-lazy-loading.module').then(m => m.RepositoryLazyLoadingModule)
                    },
                    {
                        path: 'quotes',
                        loadChildren: () => import('./views/pages/quotes/quotes.module').then(m => m.QuotesModule)
                    },
                    {
                        path: 'report-templates',
                        loadChildren: () => import('./views/pages/report-templates/report-templates.module').then(m => m.ReportTemplatesModule)
                    },
                    {
                        path: 'properties/construction-costs',
                        loadChildren: () => import('./views/pages/construction-costs/construction-costs-lazy-loading.module').then(m => m.ConstructionCostsLazyLoadingModule)
                    },
                    {
                        path: 'properties/property-construction-costs',
                        loadChildren: () => import('./views/pages/property-construction-costs/property-construction-costs-lazy-loading.module').then(m => m.PropertyConstructionCostsLazyLoadingModule)
                    }
                ]
            },
            {
                path: 'post-login',
                component: PostLoginComponent
            },
            {
                path: 'multimedia',
                loadChildren: () => import('./views/pages/multimedia/multimedia.module').then(m => m.MultimediaModule),
            },
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            { path: '**', redirectTo: 'error/403', pathMatch: 'full' },
        ],
    },
    { path: '', redirectTo: 'mad-auth', pathMatch: 'full' },
    { path: '**', redirectTo: 'error/error-3', pathMatch: 'full' },
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forRoot(routes, { enableTracing: false, paramsInheritanceStrategy: 'always' }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {
}
